import { useLocation, useNavigate, Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { name: "Experience", hash: "#experience", testid: "nav-link-experience" },
  { name: "Live Features", hash: "#features", testid: "nav-link-features" },
  { name: "Manifesto", hash: "#manifesto", testid: "nav-link-manifesto" },
  { name: "App Preview", hash: "#preview", testid: "nav-link-preview" },
  { name: "Contact & Report", hash: "#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (hash) => {
    if (location.pathname !== "/") {
      navigate("/" + hash);
    } else {
      scrollToId(hash);
    }
  };

  return (
    <header className="fixed top-5 inset-x-4 z-50 flex justify-center">
      <nav className="glass rounded-full pl-4 pr-2 py-2 flex items-center gap-1 max-w-6xl w-full justify-between shadow-[0_8px_32px_rgba(0,0,0,0.5)]">
        <button
          data-testid="nav-logo"
          onClick={() => go("#experience")}
          className="flex items-center gap-2.5 shrink-0 group"
        >
          <img
            src="/assets/icon.png"
            alt="IN-It app icon"
            className="w-11 h-11 rounded-2xl transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3"
          />
          <span className="font-display font-extrabold text-xl tracking-tight text-white">
            IN<span className="text-brand-gradient">-itapp</span>
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={l.testid}
              onClick={() => go(l.hash)}
              className="px-3.5 py-2 text-sm text-zinc-400 hover:text-white rounded-full transition-colors duration-200"
            >
              {l.name}
            </button>
          ))}
          <Link
            to="/privacy"
            data-testid="nav-link-privacy"
            className="px-3.5 py-2 text-sm text-zinc-400 hover:text-white rounded-full transition-colors duration-200"
          >
            Privacy Policy
          </Link>
        </div>

        <button
          data-testid="nav-early-access-btn"
          onClick={() => go("#download")}
          className="shrink-0 rounded-full bg-gradient-to-r from-[#FF8A3D] to-[#FF3D3D] text-white text-sm font-bold px-5 py-2.5 transition-transform duration-200 hover:scale-105 active:scale-95"
        >
          Download now
        </button>
      </nav>
    </header>
  );
};
